import { ContactProfilePhoto } from './contact-profile-photo';
import { ProfilePhoto } from './profile-photo';

export { usePhotoStore } from './use-photo-store';
export const Photos = {
  ProfilePhoto,
  ContactProfilePhoto,
};
